import accomodationService from "@services/accomodation.service";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useLocation } from "react-router-dom";
import sessionStorageService from '@services/sessionStorage.service';
import { Location } from "@models/location.model";

// [NUOVO] Helper che invia un messaggio a React Native se siamo dentro la WebView,
// altrimenti usa window.open come fallback (browser normale, sviluppo, ecc.)
const openExternalUrl = (url: string) => {
  if ((window as any).ReactNativeWebView) {
    (window as any).ReactNativeWebView.postMessage(
      JSON.stringify({ type: 'OPEN_URL', data: { url } })
    );
  } else {
    window.open(url, '_blank');
  }
};

export default function ShareButton(props: { title: string | undefined }) {
  const loc = useLocation();
  const qrCodeId = loc.pathname.split("/")[1];
  const { t } = useTranslation();

  const [location, setLocation] = useState<Location | undefined>(undefined);

  useEffect(() => {
    function getHomePageData(accomodationIdQrCode: string) {
      try {
        accomodationService.getLocation(accomodationIdQrCode)
          .then(response => {
            sessionStorage.setItem('location', JSON.stringify(response));
            setLocation(response);
          })
          .catch(error => {
            console.log(error);
          });
      } catch (error) {
        console.log(error);
      }
    }

    const cached = sessionStorageService.getLocationSS();

    if (cached) {
      setLocation(cached);
    } else {
      const qrCodeId = loc.pathname.split("/")[1];
      getHomePageData(qrCodeId);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  if (!location) return null;

  const { fullAddress, city, country } = location;

  const whatsappShare = (id: string) => {
    const url = `https://hostyble.netlify.app/open-app?qrCodeId=${encodeURIComponent(id)}`;
    const msg = t('text.whatsapp', {
      houseName: props?.title,
      address: fullAddress,
      city: city,
      state: country,
      link: url
    });
    const urlWhatsApp = `https://wa.me/?text=${encodeURIComponent(msg)}`;

    // [MODIFICATO] Sostituito window.open(urlWhatsApp, '_blank') con openExternalUrl.
    // Su iOS WebView, window.open viene bloccato → la condivisione si apriva come
    // versione web e si bloccava. Ora il link viene inviato a React Native tramite
    // postMessage, che lo apre con Linking.openURL() → WhatsApp nativo si apre correttamente.
    openExternalUrl(urlWhatsApp);
  };

  return (
    <a
      type="button"
      onClick={() => whatsappShare(qrCodeId)}
      className="bg-transparent border-none cursor-pointer"
    >
      <img src="/images/share.png" alt="Condividi" className="icon_float" />
    </a>
  );
}
